import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import _defineProperty from "/buddy/cc-maintainer-fe/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
export function fetchWikiCategories(_ref) {
  var dispatch = _ref.dispatch;
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return dispatch('api', {
    method: 'get',
    url: 'wiki-categories',
    params: _objectSpread({
      limit: 20,
      orderBy: 'name'
    }, payload === null || payload === void 0 ? void 0 : payload.params)
  }, {
    root: true
  });
}
export function fetchWikiTreeCategories(_ref2) {
  var dispatch = _ref2.dispatch,
    commit = _ref2.commit;
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return dispatch('api', {
    method: 'get',
    url: "wiki-categories/tree/".concat(payload.id ? payload.id : ''),
    params: _objectSpread(_objectSpread({
      limit: 20
    }, payload === null || payload === void 0 ? void 0 : payload.params), {}, {
      orderBy: 'name'
    })
  }, {
    root: true
  }).then(function (_ref3) {
    var _ref3$data = _ref3.data,
      data = _ref3$data.data,
      meta = _ref3$data.meta;
    meta && commit("SET_META", meta);
    return data;
  });
}
export function fetchCategoryOccurrences(_ref4, _ref5) {
  var dispatch = _ref4.dispatch;
  var id = _ref5.id,
    params = _ref5.params;
  return dispatch('api', {
    method: 'get',
    url: "wiki-categories/".concat(id, "/relatives"),
    params: _objectSpread({
      limit: 10
    }, params)
  }, {
    root: true
  });
}
export function fetchCategoryAncestors(_ref6, id) {
  var dispatch = _ref6.dispatch;
  return dispatch('api', {
    method: 'get',
    url: "wiki-categories/tree/".concat(id, "/ancestors")
  }, {
    root: true
  });
}
export function setSelectedNode(_ref7, payload) {
  var commit = _ref7.commit;
  if (payload) {
    var id = payload.id,
      nodes = payload.nodes;
    var findId = function findId(items) {
      return items.reduce(function (a, item) {
        if (a) return a;
        if (item.id === id) return item.category_id;
        if (item.children) return findId(item.children);
      }, null);
    };
    commit('SET_SELECTED_NODE', {
      id: id,
      category_id: findId(nodes)
    });
  } else {
    commit('SET_SELECTED_NODE', null);
  }
}
export function deleteCategories(_ref8, payload) {
  var dispatch = _ref8.dispatch,
    commit = _ref8.commit;
  return dispatch('api', {
    url: 'wiki-categories/tree/action',
    method: 'patch',
    data: {
      pivot_ids: payload.data.length ? payload.data.join(',') : payload.data,
      action: payload.action
    }
  }, {
    root: true
  });
}
export function restoreCategories(_ref9, payload) {
  var dispatch = _ref9.dispatch,
    commit = _ref9.commit;
  return dispatch('api', {
    url: 'wiki-categories/tree/action',
    method: 'patch',
    data: {
      pivot_ids: payload.data.length ? payload.data.join(',') : payload.data,
      action: payload.action
    }
  }, {
    root: true
  });
}

/**
 * @param commit
 * @param {Object} payload
 * @param {number} payload.id
 * @param {string} payload.name
 */
export function toggleCategoryHistoryDialog(_ref10, payload) {
  var commit = _ref10.commit;
  commit('TOGGLE_HISTORY_CATEGORY_ID', payload !== null && payload !== void 0 && payload.id ? payload : {
    id: 0,
    name: ''
  });
}

/**
 * @param commit
 * @param {Object} payload
 * @param {number} payload.id
 * @param {string} payload.name
 */
export function setCategoryDeleteGlobally(_ref11, payload) {
  var commit = _ref11.commit;
  commit('SET_CATEGORY_DELETE_GLOBALLY', payload);
  if (!payload) {
    commit('SET_CATEGORY_CHILDREN_COUNT', 0);
  }
}

/**
 * API request to fetch all the actions for single category.
 * @param dispatch
 * @param id
 * @returns {*}
 */
export function getCategoryActions(_ref12, _ref13) {
  var dispatch = _ref12.dispatch;
  var id = _ref13.id;
  return dispatch('api', {
    url: 'wiki-categories/tree/' + id + '/actions'
  }, {
    root: true
  }).then(function (response) {
    return response.data.data;
  });
}

/**
 * Get Report data for given root id.
 * @param dispatch
 * @param rootId
 */
export function getReport(_ref14, _ref15) {
  var dispatch = _ref14.dispatch;
  var rootId = _ref15.rootId,
    page = _ref15.page;
  return dispatch('api', {
    url: 'wiki-categories/tree/' + rootId + '/report',
    params: {
      page: page
    }
  }, {
    root: true
  }).then(function (response) {
    return response.data;
  });
}

/**
 * Get count of category children.
 * @param dispatch
 * @param commit
 * @param {number} id
 */
export function getCountCategoryChildren(_ref16, id) {
  var dispatch = _ref16.dispatch,
    commit = _ref16.commit;
  return dispatch('api', {
    method: 'get',
    url: "wiki-categories/".concat(id, "/nodes/count")
  }, {
    root: true
  }).then(function (_ref17) {
    var count = _ref17.data.count;
    commit("SET_CATEGORY_CHILDREN_COUNT", count);
  });
}

/**
 * @param dispatch
 * @param commit
 * @param {number} id
 */
export function deleteGlobally(_ref18, id) {
  var dispatch = _ref18.dispatch,
    commit = _ref18.commit;
  return dispatch('api', {
    method: 'put',
    url: "wiki-categories/".concat(id, "/delete")
  }, {
    root: true
  }).then(function (_ref19) {
    var data = _ref19.data;
    commit('SET_IS_DELETING_PROCESS', true);
    return data.message;
  });
}
export function setDeletedCategory(_ref20, payload) {
  var commit = _ref20.commit;
  commit('SET_DELETED_CATEGORY', payload);
}
export function setDeletingProcess(_ref21, payload) {
  var commit = _ref21.commit;
  commit('SET_IS_DELETING_PROCESS', payload);
}